import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { sessionSubject } from "../shared/constants/common.constants";

@Injectable({
  providedIn: "root",
})
export class CommonApiService {
  private baseUrl = environment?.apiBase_Url;
  private token: string = '';
  private headers = {};

  constructor(private http: HttpClient) {
    if (localStorage.getItem('session')?.length) {
      this.token = localStorage.getItem('session') as string;
      this.headers = {
        headers: {
          Authorization: `Bearer ${this.token}`,
        },
      }
    }
    sessionSubject.subscribe({
      next: () => {
        this.updateHeaders();
      }
    });
    this.updateHeaders();
  }

  updateHeaders() {
    if (localStorage.getItem('session')?.length) {
      this.token = localStorage.getItem('session') as string;
      this.headers = {
        headers: {
          Authorization: `Bearer ${this.token}`,
        },
      }
    }
  }

  get(url: string, needToken?: boolean): Observable<any> {
    return this.http.get(
      `${this.baseUrl}${url}`,
      needToken ? this.headers : undefined
    );
  }

  post(url: string, body?: Object, needToken?: boolean, specialToken?: string): Observable<any> {
    if (specialToken) {
      this.headers = {
        headers: {
          Authorization: `Bearer ${specialToken}`,
        },
      }
    }
    return this.http.post(
      `${this.baseUrl}${url}`,
      body,
      needToken ? this.headers : undefined,
    );
  }

  // put(url: any, body: any): Observable<Object> {
  //   return this.http.post(`${this.baseUrl}${url}`, body);
  // }

  // delete(url: any,id: any): Observable<any> {
  //   return this.http.delete(`${this.baseUrl}${url}/${id}`);
  // }
}
